import React, { PureComponent } from 'react';

class AgeField extends PureComponent {
    render() {
        const { ageGroup, setAgeGroup } = this.props;

        return (
            <div className="fieldwrap">
                <label htmlFor="age">How old are you?</label>
                <div className="row">
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('16-19')}
                            className={ageGroup == '16-19' ? 'radio __active __padded' : 'radio __padded'}
                        >
                            <input type="radio" name="age" /> 16-19
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('20-29')}
                            className={ageGroup == '20-29' ? 'radio __active __padded' : 'radio __padded'}
                        >
                            <input type="radio" name="age" /> 20-29
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('30-39')}
                            className={ageGroup == '30-39' ? 'radio __active __padded' : 'radio __padded'}
                        >
                            <input type="radio" name="age" /> 30-39
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('40-49')}
                            className={ageGroup == '40-49' ? 'radio __active __padded' : 'radio __padded'}
                        >
                            <input type="radio" name="age" /> 40-49
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('50-59')}
                            className={ageGroup == '50-59' ? 'radio __active __padded' : 'radio __padded'}
                        >
                            <input type="radio" name="age" /> 50-59
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('60-64')}
                            className={ageGroup == '60-64' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="age" /> 60-64
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('65 and above')}
                            className={ageGroup == '65 and above' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="age" /> 65 and above
                        </label>
                    </div>
                    <div className="col-sm-4">
                        <label
                            onClick={e => setAgeGroup('Prefer not to say')}
                            className={ageGroup == 'Prefer not to say' ? 'radio __active' : 'radio'}
                        >
                            <input type="radio" name="age" /> Prefer not to say
                        </label>
                    </div>
                </div>
            </div>
        );
    }
}

export default AgeField;



// WEBPACK FOOTER //
// ./src/Form/AgeField.js